<template>
	<el-main class="Team">
		<ContentNav :bannerTextIMG="require('../../assets/Team/bannerText.png')" :bannerimgIMG="Url.imgUrl + this.$store.state.NavList[2].banner"></ContentNav>
		<div class="content">
			<div class="container">
				<Menu :Menulist="{MenuList}" :checkedValue="lawyerType" @changeNavIndex="loadLawyer"></Menu>
				<!-- 搜索 -->
				<div class="selectBox" >
					<div class="selectBox-item">
						<div class="title">按拼音字母搜索</div>
						<el-input placeholder="请输入内容" v-model="userName" style="width:500px;" @keyup.enter.native="changeName()">
							<el-button @click="changeName()" slot="append" icon="el-icon-search"></el-button>
						</el-input>
					</div>
					<div class="pinyin">
						<span :class="{'pinyin-item':true,'act':pinYin==item}" v-for="(item,index) in pyList" :key="index" @click="changePinYin(item)">{{item}}</span>
					</div>
					<!-- 列表 -->
					<div class="BoxList">
						<div class="BoxList-item" v-for="(item,index) in lawyerList" :key="index">
							<div class="UserImg">
								<img :src="Url.imgUrl+item.photo" alt="" />
							</div>
							<div class="UserInfo">
								<div class="Name">{{item.name}}</div>
								<div class="title">{{item.lawyerType}}</div>
								<div class="more" @click="showDetails(item.id)">详情>>></div>
							</div>
						</div>
					</div>
					<el-pagination background :current-page.sync="pageIndex" layout="prev, pager, next" :total="pagesNum" @current-change="topage" style="text-align:center;margin-top:20px">
					</el-pagination>
				</div>
			</div>
		</div>
		<Icongroup></Icongroup>
		
	</el-main>
</template>

<script>
	import ContentNav from "../../components/ContentNav";
	import Menu from "../../components/Menu";
	import Icongroup from "../../components/Icon_group";
	export default {
		components: {
			ContentNav,
			Menu,
			Icongroup
		},
		metaInfo() {
			return {
				title: `专业团队-${this.SystemOption.seoTitle ?? ''}`,
				meta: [{ // set meta
					name: 'keywords',
					content: this.SystemOption.seoKeyWord
				},{ // set meta
					name: 'description',
					content: this.SystemOption.seoDescribe
				}]
			}
		},
		props: ["lawyerType"],
		data() {
			return {
				MenuList: [],
				lawyerList:[],
				pyList: ["全部", "A", "B", "C", "D", "E", "F","G", "H", "I", "J", "K", "L","M", "N", "O", "P", "Q", "R","S", "T", "U", "V", "W", "X","Y", "Z"],
				//列表条件
				userName: "", //输入框的内容
				pinYin: "全部", //选中的拼音字母
				lawyerTypeNum: 0,
				lawyerTypeName:'',
				pagesNum: 0,
				pageIndex: 1,
				SystemOption: [] //SEO 配置
			};
		},
		created() {
			this.loadNav();
			this.loadLawyerType();
			this.loadSeo();
			this.lawyerTypeName = this.lawyerType;
		},
		methods: {
			loadNav() { 
				//初始化路径数据
				this.$store.state.Currentposition = [{
					path: '/',
					name: '首页'
				}, {
					path: '/team.html',
					name: '专业团队'
				}]
			},
			loadSeo(){
				//获取SEO配置
				this.axios.get(this.Url.apiUrl + "SystemOption/GetSystemOption").then(res => this.SystemOption = res.data);
			},
			loadLawyerType() {
				let that = this;
				let lawyertype = that.$route.params.lawyerType;
				//获取律师类别
				that.axios({
					type: "get",
					url: that.Url.apiUrl + "Lawyer/GetLawyerType",
				}).then((res) => {
					let data = new Array();
					data.push({
						id: 0,
						name: "全部",
						value: '',
						route: {
							path: "/team.html"
						}
					});
					let len = res.data.length;
					for (let i = 0; i < len; i++) {
						if(lawyertype == res.data[i].enName){
							//确认默认选择项id
							that.lawyerTypeNum = res.data[i].id;
						}
						data.push({
							id: res.data[i].id,
							name: res.data[i].name,
							value: res.data[i].enName,
							route: {
								name: 'team',
								params: {
									'lawyerType': res.data[i].enName
								}
							}
						});
					}

					that.MenuList = data;
					that.getList();
				});
			},
			loadLawyer(num,v) {
				let that = this;
				that.lawyerTypeNum = num;
				that.lawyerTypeName = v;
				that.getList();
			},
			//改变搜索内容
			changeName() {
				let that = this;
				that.getList();
			},
			//改变拼音选项
			changePinYin(item) {	
				let that = this;
				that.pageIndex = 1;
				that.pinYin = item;
				that.getList();
			},
			getList(page) {				
				let that = this;
				let data = {
					page: page=='' || page==undefined? 1:that.pageIndex ,
					name: that.userName,
					pinyin: that.pinYin,
					lawyertype: that.lawyerTypeNum
				};
				that.getPageList(data);
			},
			getPageList(params) {
				let that = this;
				let pinyin = params.pinyin == '全部' ? "" : params.pinyin;
				that.axios({
					type: "get",
					url: that.Url.apiUrl + "Lawyer/GetLawyerTypeUserList",
					params: {
						page: params.page,
						limit: 10,
						name: params.name,
						lawyerType: params.lawyertype,
						PinYinName: pinyin
					}
				}).then((res) => {
					let result = res.data;
					that.lawyerList = result.data;
					that.pagesNum = result.count;

				});
			},
			//点击分页事件
			topage(val) {
				let that = this;
				that.pageIndex = val;
				that.getList(val);
				// that.getPageList({
				// 	page: that.pageIndex,
				// 	name: that.name,
				// 	pinyin: that.pinyin,
				// 	lawyertype: that.lawyerType
				// });
			},
			getPageNumber(count) {
				return Math.ceil(count / 10);
			},
			showDetails(id) {
				let that = this;
				if((that.lawyerTypeName || '') == '') {
					that.$router.push({
						name: 'team-all-details',
						params: {
							'id': id
						}
					});
				}else{
					that.$router.push({
						name: 'team-details',
						params: {
							'id': id,
							'lawyerType': that.lawyerTypeName
						}
					});
				}
				
			}
		}
	};
</script>

<style lang="scss" scoped>
	.content {
		position: relative;
		width: 100%;

		.container {
			position: relative;
			width: 1200px;
			display: flex;
			margin: 0 auto;
			padding: 40px 0;
			justify-content: space-between;

			@media screen and (max-width: 768px) {
				width: 100%;
				display: block;
				padding: 26px 21px;
			}

			.menu {
				@media screen and(max-width: 768px) {
					display: none;
				}
			}

			.selectBox {
				flex: 0 0 950px;

				@media screen and (max-width: 768px) {
					width: 100%;
				}

				.selectBox-item {
					width: 100%;
					display: flex;
					height: 40px;
					margin-bottom: 15px;
					justify-content: space-between;

					.title {
						display: flex;
						align-items: center;
						color: #707070;
						flex: 0 0 30%;

						@media screen and (max-width: 768px) {
							display: none;
						}
					}
				}

				.pinyin {
					display: flex;
					justify-content: space-between;
					color: #707070;
					font-size: 14px;

					span {
						cursor: pointer;
					}

					@media screen and (max-width: 768px) {
						flex-wrap: wrap;
						line-height: 25px;
						background-color: #fff;

						span {
							display: block;
							flex: 0 0 12.5%;
							text-align: center;
						}
					}
				}

				.BoxList {
					position: relative;
					display: flex;
					justify-content: space-between;
					align-items: center;
					flex-wrap: wrap;
					width: 100%;
					margin-top: 30px;

					@media screen and (max-width: 768px) {
						width: 100%;
					}

					.BoxList-item {
						flex: 0 0 460px;
						width: 460px;
						height: 180px;
						background-color: #ffffff;
						box-shadow: 0px 0px 6px 0px rgba(166, 166, 166, 0.3);
						border-radius: 4px;
						margin: 15px 0;
						display: inherit;

						@media screen and (max-width: 768px) {
							display: flex;
							flex: 0 0 100%;
							width: 100%;
							height: 109px;
							overflow: hidden;
						}

						.UserImg {
							width: 180px;
							height: 100%;
							flex: 0 0 180px;
							overflow: hidden;

							@media screen and (max-width: 768px) {
								flex: 0 0 109px;
								width: 109px;
								height: 100%;
							}

							img {
								width: 180px;
								height: auto !important;

								@media screen and (max-width: 768px) {
									width: 109px;
								}
							}
						}

						.UserInfo {
							padding: 30px 21px;
							width: calc(100% - 180px);
							flex: 0 0 calc(100% - 180px);
							height: 100%;
							position: relative;

							@media screen and (max-width: 768px) {
								padding: 16px;
								flex: 0 0 calc(100% - 109px);
							}

							.Name {
								font-size: 16px;
								color: #202020;
								line-height: 24px;
								font-weight: 600;
							}

							.title {
								color: #202020;
								line-height: 30px;
								font-size: 15px;
							}

							.more {
								color: #d0a971;
								font-size: 14px;
								position: absolute;
								bottom: 20px;
								right: 20px;
								cursor: pointer;
							}
						}
					}
				}
			}

			.details {
				flex: 0 0 950px;
				display: block;

				.details-title {
					color: #ae8a55;
					font-weight: 600;
					margin-bottom: 28px;

					@media screen and (max-width: 768px) {
						text-align: center;
					}
				}

				.UuerInfo {
					width: 100%;
					display: flex;
					justify-content: space-between;
					height: auto;

					@media screen and(max-width: 768px) {
						display: block;
					}

					.UserImg {
						flex: 0 0 210px;
						width: 210px;
						height: 210px;
						overflow: hidden;

						@media screen and(max-width: 768px) {
							width: 129.6px;
							height: 166px;
							margin: 0 auto;
						}

						img {
							width: 210px;
							height: auto;

							@media screen and(max-width: 768px) {
								width: 129.6px;
							}
						}
					}

					.Userlabel {
						display: block;
						width: 710px;
						overflow: hidden;

						@media screen and(max-width: 768px) {
							width: 100%;
						}

						.label-item {
							height: 83px;
							position: relative;

							@media screen and(max-width: 768px) {
								height: auto;
							}

							.bottom {
								position: absolute;
								top: 9px;

								@media screen and(max-width: 768px) {
									top: 0px;
								}
							}

							.title {
								width: 238px;
								height: 33px;
								background-color: #caa165;
								color: #fff;
								line-height: 33px;

								@media screen and(max-width: 768px) {
									width: 142px;
									height: 24.2px;
									line-height: 24.2px;
									font-size: 13px;
								}

								img {
									margin: 0 10px;
								}
							}

							.context {
								display: block;
								padding: 0 30px;
								height: 50px;
								line-height: 50px;
								color: #787878;

								@media screen and(max-width: 768px) {
									font-size: 11px;
								}
							}
						}
					}
				}

				.Userdetails {
					color: #787878;
					font-size: 14px;
					line-height: 24px;
				}

				.BoxList {
					display: flex;
					justify-content: space-between;

					@media screen and(max-width: 768px) {
						display: block;
					}

					.BoxList-item {
						flex: 0 0 460px;
						width: 460px;
						height: 180px;
						background-color: #ffffff;
						box-shadow: 0px 0px 6px 0px rgba(166, 166, 166, 0.3);
						border-radius: 4px;
						margin: 15px 0;
						display: inherit;

						@media screen and(max-width: 768px) {
							width: 308px;
							height: 106px;
							margin: 15px auto;
							display: flex;
						}

						.UserImg {
							width: 180px;
							height: 100%;
							overflow: hidden;

							@media screen and(max-width: 768px) {
								width: 109px;
							}

							img {
								width: 180px;
								height: auto !important;

								@media screen and(max-width: 768px) {
									width: 109px;
									height: auto !important;
								}
							}
						}

						.UserInfo {
							padding: 25px 21px;
							width: calc(100% - 180px);
							height: 100%;
							position: relative;

							@media screen and(max-width: 768px) {
								padding: 16px;
								width: calc(100% - 109px);
								height: auto !important;
							}

							.Name {
								font-size: 14px;
								color: #202020;
								line-height: 24px;
								font-weight: 600;
							}

							.title {
								color: #202020;
								line-height: 24px;
								font-size: 14px;
							}

							.more {
								color: #d0a971;
								font-size: 14px;
								position: absolute;
								bottom: 20px;
								right: 20px;
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}

	.mt-3 {
		margin-top: 30px;
	}

	.pinyin-item.act {
		color: #D0A971;
	}
</style>
